<!-- 课堂点评-点评学员列表 -->
<template>
  <div data-test="course-comment-student-list">
    <div class="course-comment-student-list full-page" v-if="detail.classTime">
      <div class="class-info" v-if="detail">
        <div class="class-time">
          {{ detail.classTime.date | formatDatetime(new Date(detail.classTime.date).getFullYear()===new Date().getFullYear()?'MM月dd日 hh:mm':'yyyy年MM月dd日 hh:mm') }}（{{
            detail.classTime.weekdayName
          }}） {{ detail.classTime.startTime }}-{{ detail.classTime.endTime }}·{{
  detail.courseArrange.courseAmount
}}{{ lessonUnit }}
        </div>
        <div class="van-ellipsis">
          <span class="l2" >
            {{ detail.courseArrange.curriculumName }}
          </span>
          <!-- <span class="l2" v-if="teacherName"><span style="font-weight:bold;"> · </span>{{ teacherName }}</span> -->
        </div>
        <div class="van-ellipsis" v-if="detail.courseArrange.className">
          <span class="l2" >
            {{ detail.courseArrange.className }}
          </span>
          <!-- <span class="l2" v-if="teacherName"><span style="font-weight:bold;"> · </span>{{ teacherName }}</span> -->
        </div>
        <div class="van-ellipsis" v-if="teacherName">
          上课老师：<span class="l2"  >
            {{ teacherName }}
          </span>
          <span class="l2"  v-if="detail.courseArrange.classRoomName">
            {{ detail.courseArrange.classRoomName }}
          </span>
        </div>
      </div>
      <div class="tips">
        列表只展示出勤和迟到的学员。
        <!-- ，批量点评将覆盖选中学员的点评内容，且仅覆盖老师点评内容 -->
      </div>

      <div class="wrap">
        <div class="card" v-for="item in list" :key="item.studentId">
          <div v-if="item.commentRecordStatus == 0" class="cg">
          </div>
          <div class="card-head flex-between">
            <van-checkbox v-model="item.checked" icon-size="var(--fs-ex1)" class="check-icon" v-if="isBatch"
              :disabled="!!item.id && item.commentRecordStatus === 1" />
            <div class="card-head-wrap flex-between" @click="goComment(item)">
              <div>
                <div class="photo">{{ item.studentName.slice(-2) }}</div>
                &nbsp;{{ item.studentName }}&nbsp;
                <span class="status" :class="{ default: item.courseStudentStatus == 1 }">{{
                  item.courseStudentStatus == 1
                  ? '出勤'
                  : item.courseStudentStatus == 2
                    ? '迟到'
                    : ''
                }}</span>
              </div>
              <div class="card-head-r">
                <div class="card-head-r-con" v-if="!item.id && app.permission.op('add_course_comment')">
                  去点评<van-icon name="arrow" size="var(--fs-md)" color="var(--g5)" />
                </div>
                <div v-if="item.id" class="flex-center">
                  <!-- contentGlobalStatus：1 合成中 2已合成 3合成失败（含失败的会优先合成失败）	 -->
                  <span class="s-tag" v-if="item.contentGlobalStatus == 1">视频合成中</span>
                  <span class="s-tag error" v-if="item.contentGlobalStatus == 3">视频合成失败</span>
                  <van-icon name="ellipsis" class="operation-icon" size="16" v-if="item.commentRecordStatus != 0"  @click.stop="operateCurrent(item)"/>
                  <div class="card-head-r-con" v-if="item.commentRecordStatus == 0">
                    继续点评<van-icon name="arrow" size="var(--fs-md)" color="var(--g5)" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="item.id" @click="goComment(item)" class="card-content">
            <vx-mult-input-intro :list="item.commentContent.list"></vx-mult-input-intro>

            <div class="desc-line">点评人：{{ item.commentKeeperName }}</div>
            <div class="desc-line">课堂评分：{{ item.score }}</div>
          </div>

          <div class="card-bottom van-hairline--top flex-between" v-if="item.id">
            <span>{{item.commentRecordStatus == 0?'最后编辑：':'发布时间：'}} {{ item.createTime |  formatDatetime(new Date(item.createTime).getFullYear()===new Date().getFullYear()?'MM月dd日 hh:mm':'yyyy年MM月dd日 hh:mm') }}</span>
            <template v-if="item.commentRecordStatus == 0&&app.permission.op('delete_course_comment')">
                <span class="clear" @click="clearCommon(item)">清空草稿</span>
            </template>
            <span v-if="showFromTeacher&&item.commentRecordStatus !== 0">
              <template v-if="item.reviewStatus == 2">
                家长回评平均得分：<span class="score">{{ item.reviewAvgScore }}</span>
              </template>
              <template v-else>
                {{ item.reviewStatusText }}
              </template>
            </span>
          </div>
        </div>
        <van-empty image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png" description="暂无可点评学员"
          v-if="!list || (list && list.length === 0)" image-size="128" style="padding-top: calc(30%)" />
      </div>

      <div class="footer" v-if="list.length > 0">
        <template v-if="!isBatch">
          <div class="total">已点评：{{ detail.commentStudentCount }}/{{ detail.totalCommentStudentCount }}</div>
          <van-button square round type="primary" data-test="course-comment-student-list-btn-multi"
            v-if="app.permission.op('add_course_comment')" @click="() => {
                isBatch = true;
              }
              ">
            批量点评
          </van-button>
        </template>
        <template v-else>
          <div class="choosed-status">
            <div class="checked-nav" :class="{ 'all-checked': allChecked }">
              <van-checkbox @change="allCheckBoxChange" v-model="allChecked" :disabled="list.every(v=>v.commentRecordStatus===1)" icon-size="var(--fs-lg)" />全选
            </div>
          </div>
          <van-button class="ccbtn" square round block @click="cancelBatch" style="margin-right: 8px; padding: 0 12px"
            data-test="course-comment-student-list-multi-cancle">
            取消
          </van-button>
          <van-button class="cnbtn" square round block type="primary" @click="confirmComment"
            data-test="course-comment-student-list-confirm">
            立即点评({{ choosedList.length }}/{{ total }})
          </van-button>
        </template>
      </div>
    </div>
        <!-- 操作的弹窗 -->
    <van-action-sheet
      v-model="showOpMark"
      :actions="OpMarkActions"
      cancel-text="取消"
      close-on-click-action
      @cancel="showOpMark = false"
      @select="onSelectOpMark"
    >
    </van-action-sheet>
  </div>
  
</template>

<script>
export default {
  name: 'course-comment-student-list',
  data() {
    return {
      showOpMark:false,
      currentSelect:null,
      pageTitle: '课堂点评',
      allChecked: false,
      isBatch: false,
      courseArrangeId: '',
      detail: {},
      list: [],
      total: 0,
      showFromTeacher: false,
    };
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
    OpMarkActions() {
      // 若视频还在合成，则：1、仅支持“删除”操作
      let actions = [];
        if (app.permission.op('edit_course_comment') &&this.currentSelect&& this.currentSelect.contentGlobalStatus !== 1) {
          actions.push({name: "编辑",id: 1});
        }
        if (app.permission.op('delete_course_comment')) {
          actions.push({name: "删除",id: 0});
        }
      return actions;
    },
    commentList() {
      return this.list.filter(v => v.id > 0);
    },
    choosedList() {
      return this.list.filter(v => v.checked);
    },
    teacherName() {
      try {
        const teacher = this.detail.courseArrange.courseArrangeTeacherVoList.find(item => item.teacherRule == 0);
        if (teacher) {
          return teacher.teacherName;
        }
      } catch (e) {
        return ''
      }
      return ''
    }
  },
  watch: {
    choosedList(v) {
      let len = this.list.filter(v=>v.commentRecordStatus!==1).length;
      if (len === 0) {
        this.allChecked = false;
        return false;
      }
      if (v.length !== len) this.allChecked = false;
      if (v.length === len) this.allChecked = true;
    },
  },
  methods: {
    operateCurrent(item){
      if(app.permission.op('edit_course_comment')||app.permission.op('delete_course_comment')){
        this.currentSelect=item;
        this.showOpMark = true;
      }
    },
    onSelectOpMark(val) {
      //操作选择
      if (val.id == 1) {
        //修改
        this.$router.push(
            `/courseCommentEdit?type=edit&id=${this.currentSelect.id}`
          );
      } else if (val.id == 0){
        this.del();
      }
    },
    del() {
      this.$dialog
        .confirm({
          message: "确定删除么？",
        })
        .then(() => {
          this.$api.deleteComment(this.currentSelect.id).then((res) => {
            if (res.code === 200) {
              this.$toast.success("删除成功");
              this.render();
            } else {
              this.$toast.fail(res.msg);
            }
          });
        });
    },
    clearCommon(item){
      let _this=this;
      this.$dialog.confirm({
          message: '确定清空草稿？',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          messageAlign:'left',
        }).then(() => {
          _this.showLoading();
          this.$api.deleteDraft({
            commentRecordId:item.id
          }).then(res=>{
              _this.$toast.clear();
              if (res.code == 200) {
                _this.render();
              } else {
                this.$toast.fail(res.msg);
              }
          })
        }).catch(() => { })
    },
    render() {
      this.showLoading();
      this.$api
        .commentCommentList({
          courseArrangeId: this.courseArrangeId,
        })
        .then(res => {
          this.$toast.clear();
          if (res.code == 200) {
            this.detail = res.data;
            this.list = res.data.commentRecordList;
            this.total = this.list.length;
          } else {
            this.$toast.fail(res.msg);
          }
        });
    },
    allCheckBoxChange(val) {
      if (val && this.list.length !== this.choosedList.length) {
        this.list.forEach(v => {
          if (v && !v.checked  && !v.commentRecordStatus) {
            this.$set(v, 'checked', val);
          }
        });
      }
      if (!val && this.list.filter(v=>v.commentRecordStatus!==1).length == this.choosedList.length) {
        this.list.forEach(v => {
          this.$set(v, 'checked', val);
        });
      }
    },
    cancelBatch() {
      this.isBatch = false;
      this.list.forEach(v => {
        this.$set(v, 'checked', false);
      });
    },
    goComment(item) {
      if (item.id) {
        if (item.commentRecordStatus === 0) {
          this.$router.push(
            `/courseCommentEdit?type=edit&id=${item.id}`
          );
          return;
        }
        //已点评
        this.$router.push(`/commentDetail/${item.id}`);
      } else {
        if (app.permission.op('add_course_comment')) {
          this.detail.teacherName=this.teacherName;
          this.$router.push({
            name: 'courseCommentEdit',
            params: {
              isBatch: false,
              list: [item],
              courseArrangeId: this.courseArrangeId,
              campusId: this.detail.courseArrange.campusId,
              classId: this.detail.courseArrange.classId,
              curriculumId: this.detail.courseArrange.curriculumId,
              detail:this.detail,
              reviewEnable: item.reviewEnable,
            },
          });
        }
      }
    },
    confirmComment() {
      if (this.choosedList.length == 0) {
        this.$toast.fail('请选择要点评的学员');
        return;
      }
      if (this.choosedList.length === 1 && this.choosedList[0].commentRecordStatus === 0) {
        let detail = this.choosedList[0]
        this.$router.push(
          `/courseCommentEdit?type=edit&id=${detail.id}`
        );
        return;
      }
      this.doSubmit()
      // let draft = this.choosedList.filter(item => item.commentRecordStatus === 0);
      // if (draft.length) {
      //   this.$dialog.confirm({
      //     title: '提示',
      //     message: '以下学员的点评已存在草稿，批量点评将覆盖原草稿内容，是否继续点评？\n ' + draft.map(v => v.studentName).join("、"),
      //     confirmButtonText: '继续点评',
      //     cancelButtonText: '取消',
      //     messageAlign:'left',
      //   }).then(() => {
      //     this.doSubmit()
      //   }).catch(() => { })
      // } else {
      //   this.doSubmit()
      // }
    },
    doSubmit() {
      const reviewEnable = this.choosedList[0].reviewEnable;
      this.detail.teacherName=this.teacherName;
      this.$router.push({
        name: 'courseCommentEdit',
        params: {
          isBatch: this.isBatch,
          list: this.choosedList,
          courseArrangeId: this.courseArrangeId,
          campusId: this.detail.courseArrange.campusId,
          classId: this.detail.courseArrange.classId,
          curriculumId: this.detail.courseArrange.curriculumId,
          reviewEnable,
          detail:this.detail,
        },
      });
    }
  },
  created() {
    this.courseArrangeId = this.$route.params.id;

    this.$api.getCommentSet().then(res => {
      this.showFromTeacher = res.data.showFromTeacher;
    });
    this.render();

    this.$onBus('refresh-comment-student', () => {
      this.render();
      this.cancelBatch();
    });
  },
};
</script>

<style lang="scss" scoped>
.course-comment-student-list {
  display: flex;
  flex-direction: column;

  .class-info {
    padding: calc(var(--gap) * 16);
    color: var(--g6);
    background-color: var(--white);

    .class-time {
      margin-bottom: calc(var(--gap) * 4);
      color: var(--g8);
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
    }
  }

  .tips {
    margin: calc(var(--gap) * 12) calc(var(--gap) * 16);
    color: var(--g6);
  }

  .wrap {
    flex: 1;
    overflow-y: auto;
  }

  .card {
    margin: 0 calc(var(--gap) * 12) calc(var(--gap) * 12) calc(var(--gap) * 12);
    border-radius: var(--radius-sm);
    background-color: var(--white);
    position: relative;
    .cg{

      width: 32px;
      height: 32px;

      background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/cg.png);
      // background-image: url(./cg.png);
      background-size: 100% 100%;
      position: absolute;
      right: 0px;
    }
    .card-head {
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      padding-bottom: calc(var(--gap) * 12);

      .check-icon {
        display: inline-block;
        vertical-align: middle;
        margin-right: calc(var(--gap) * 16);
      }

      .photo {
        display: inline-block;
        width: calc(var(--w) * 24);
        height: calc(var(--w) * 24);
        line-height: calc(var(--w) * 24);
        border-radius: 50%;
        background-color: var(--c1);
        color: var(--white);
        text-align: center;
        vertical-align: middle;
        margin-right: calc(var(--gap) * 8);
      }

      .status {
        color: var(--c4);

        &.default {
          color: var(--g6);
        }
      }

      .card-head-wrap {
        flex: 1;
      }

      .card-head-r {
        color: var(--g6);

        .card-head-r-con {
          display: flex;
          align-items: center;
        }

        .s-tag {
          margin-right: calc(var(--gap) * 4);
          color: var(--c4);

          &.error {
            color: var(--c3);
          }
        }
      }
    }

    .card-content {
      padding: 0 calc(var(--gap) * 16) calc(var(--gap) * 12) calc(var(--gap) * 16);

      .desc-line {
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        margin-bottom: calc(var(--gap) * 8);
        color: var(--g6);
      }
    }

    .card-bottom {
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      color: var(--g6);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      .dfart{
        color: var(--c4);
      }
      .clear{
        color: var(--c1);
      }

      .score {
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        color: var(--c4);
      }
    }
  }

  .footer {
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .total {
      line-height: calc(var(--w) * 40);
    }

    .van-button {
      min-width: 20px;
      height: calc(var(--w) * 40);
      padding: 0 8px;
    }

    .ccbtn {
      flex: 2;
    }

    .cnbtn {
      flex: 5;
    }

    .choosed-status {
      flex: 1;
      white-space: nowrap;
      margin-right: calc(var(--gap) * 16);

      .checked-nav {
        margin-right: calc(var(--gap) * 16);
        display: flex;
        align-items: center;
        color: var(--g6);

        >div {
          margin-right: calc(var(--gap) * 4);
        }

        &.all-checked {
          color: var(--g8);
        }
      }
    }
  }
}
</style>